import React, { Fragment } from "react";
import PropTypes from "prop-types";

import LoadingSnackbarManager from "./loadingSnackbarManager";
import Spinner from "component/atoms/spinner/index";
import SVGIcons from "assets/icon";
//import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import CSSTransitionGroup from "react-addons-css-transition-group";
import "./loadingSnackbar.styl";
import "./test.css";

class LoadingSnackbar extends React.Component {
  static propTypes = {
    enterTimeout: PropTypes.number,
    leaveTimeout: PropTypes.number,
  };

  static defaultProps = {
    enterTimeout: 400,
    leaveTimeout: 400,
  };

  constructor(props) {
    super(props);
    this.state = {
      notification: {},
      dots: "",
    };
    LoadingSnackbarManager.addChangeListener(this.handleNotificationChange);
  }

  componentDidUpdate = () => {
    const { notification } = this.state;
    const { timeOut } = notification;

    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (timeOut > 0) {
      this.timer = setTimeout(this.requestHide, timeOut);
    }

    // if type is loading, append dot(.) animation
    if (this.dotTimer) {
      clearTimeout(this.dotTimer);
      this.dotTimer = null;
    }
    if (notification.type == "loading") {
      this.dotTimer = setTimeout(this.handleDotAnimation.bind(this), 500);
    }
  };

  componentWillUnmount = () => {
    LoadingSnackbarManager.removeChangeListener(this.handleNotificationChange);
    if (this.timer) {
      clearTimeout(this.timer);
    }
  };

  handleNotificationChange = (notification) => {
    this.setState({
      notification: notification,
    });
  };
  handleDotAnimation = () => {
    let { dots } = this.state;
    if (dots.length >= 5) {
      dots = "";
    } else {
      dots += ".";
    }
    this.setState({ dots: dots });
  };
  requestHide = () => {
    const { onRequestHide } = this.props;
    if (onRequestHide) {
      onRequestHide();
    }
  };

  renderNotificationStateIcon = () => {
    const { notification } = this.state;

    if (notification.type === "loading") {
      return <Spinner />;
    } else if (notification.type === "complete") {
      return <SVGIcons.SVGCheckmarkIcon className="checkmarkIcon" />;
    } else {
      return false;
    }
  };

  render() {
    const { enterTimeout, leaveTimeout } = this.props;
    const { notification, dots } = this.state;
    const key = notification.id || new Date().getTime();
    const message = notification.message || "";

    let isVisible = false;
    if (notification.type === "complete" || notification.type === "loading") {
      isVisible = true;
    }

    let displayDots = "";
    if (notification.type === "loading") {
      displayDots = dots;
    }
    return (
      <React.Fragment>
        <div>
          <CSSTransitionGroup
            transitionName="notification"
            //transitionAppearTimeout={500}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            {isVisible && (
              <div key={1} className="loading-snackbar-container">
                <div className="loading-snackbar-spinner">
                  {this.renderNotificationStateIcon()}
                </div>
                <div className="loading-snackbar-text">
                  {message + displayDots}
                </div>
              </div>
            )}
          </CSSTransitionGroup>
        </div>
      </React.Fragment>
    );
  }
}

export default LoadingSnackbar;
